"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("apps/dashboard");
require("apps/shop");
require("apps/outlet");
require("apps/damaged");
require("apps/discount");
require("apps/pricelists");
require("apps/order-list");
require("apps/cart");
require("apps/profile");
require("apps/contact");
require("apps/card");
require("apps/search");
require("apps/group");
exports.default = angular.module('rinca.apps', [
    'rinca.apps.dashboard',
    'rinca.apps.shop',
    'rinca.apps.outlet',
    'rinca.apps.damaged',
    'rinca.apps.discount',
    'rinca.apps.pricelist',
    'rinca.apps.orders',
    'rinca.apps.cart',
    'rinca.apps.profile',
    'rinca.apps.contact',
    'rinca.apps.card',
    'rinca.apps.search',
    'rinca.apps.group'
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/index.ts
// module id = 340
// module chunks = 0